import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { enableIndexedDbPersistence, getFirestore } from 'firebase/firestore';
import { getMessaging, isSupported } from 'firebase/messaging';

export const firebaseConfig = {
  apiKey: 'AIzaSyDntOau_27VeRfI96ZL_u3r9rGH60lmmaI',
  authDomain: 'manobra-saaevr.firebaseapp.com',
  projectId: 'manobra-saaevr',
  storageBucket: 'manobra-saaevr.firebasestorage.app',
  messagingSenderId: '579563806081',
  appId: '1:579563806081:web:37e69c7044c27f81c0dc80',
  measurementId: 'G-6TM4Y301PZ'
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

enableIndexedDbPersistence(db).catch((err) => {
  console.warn('Persistência offline do Firestore não pôde ser habilitada:', err);
});

let messagingInstancePromise: Promise<ReturnType<typeof getMessaging> | null> | null = null;

export const getMessagingIfSupported = async () => {
  if (!messagingInstancePromise) {
    messagingInstancePromise = isSupported()
      .then((supported) => (supported ? getMessaging(app) : null))
      .catch((err) => {
        console.warn('Firebase Messaging não suportado neste navegador/contexto:', err);
        return null;
      });
  }

  return messagingInstancePromise;
};
